<script setup lang="ts">
import { type PropType, defineComponent } from 'vue';
import BadIcon from '../../../icons/StatusBadIcon.vue';
import ExcellentIcon from '../../../icons/StatusExcellentIcon.vue';
import NeutralIcon from '../../../icons/StatusNeutralIcon.vue';
import PollutedIcon from '../../../icons/StatusPollutedIcon.vue';
import WarningIcon from '../../../icons/StatusWarningIcon.vue';

type Status = 'excellent' | 'neutral' | 'polluted' | 'warning' | 'bad';

const iconTable: Record<Status, { component: ReturnType<typeof defineComponent>, label: string }> = {
  excellent: { component: ExcellentIcon, label: 'symbolStatus.excellent' },
  neutral: { component: NeutralIcon, label: 'symbolStatus.neutral' },
  polluted: { component: PollutedIcon, label: 'symbolStatus.polluted' },
  warning: { component: WarningIcon, label: 'symbolStatus.warning' },
  bad: { component: BadIcon, label: 'symbolStatus.bad' }
};

const props = defineProps({
  status: {
    type: String as PropType<Status>,
    required: true,
  },
});
</script>

<template>
  <div class="flex flex-col items-center h-full w-full justify-center">
    <div class="flex flex-1 items-center justify-center text-foreground">
      <component :is="iconTable[props.status]['component']" />
    </div>
    <div class="text-onboard-shade2 text-m text-foreground opacity-75">
      {{ $t(iconTable[props.status]['label']) }}
    </div>
  </div>
</template>
